import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  BalanceOperationControlsEntity,
  BalanceOperationControlsService,
  UpdateBalanceOperationControlsDto,
} from 'services/openapi';

import { BalanceOperationControlsServiceKeys } from '../queries';

export const useUpdateBalanceOperationControlsMutation = () => {
  const queryClient = useQueryClient();

  const { isLoading, error, data, isError, isSuccess, mutate, mutateAsync } =
    useMutation<
      BalanceOperationControlsEntity,
      Error,
      UpdateBalanceOperationControlsDto
    >({
      mutationFn: (variables: UpdateBalanceOperationControlsDto) =>
        BalanceOperationControlsService.balanceOperationControlsControllerUpdateControls(
          variables,
        ),
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [
            BalanceOperationControlsServiceKeys.GET_BALANCE_OPERATION_CONTROLS,
          ],
        });
      },
    });

  return {
    isLoading,
    isSuccess,
    error,
    data,
    isError,
    mutate,
    mutateAsync,
  };
};
